import React from 'react';
import useStore from '../../useStore';
import logo from "../../assests/imagenes/La Romana-logo completo-negro.png";
import { useNavigate } from 'react-router-dom';
import styles from './HeaderVolver.module.css';

const HeaderVolver= ({ tituloPrincipal, tituloDestacado }) => {
  return (
    <section className={styles.header_section}>
      <div className={styles.div_header}> 
        <div className={styles.title_container}>
          <h1 className={styles.page_title}>
            <span className={styles.titulo_principal}>{tituloPrincipal}</span>
            <span className={styles.titulo_destacado}>{tituloDestacado}</span>
          </h1>
        </div>
        <div className={styles.div_logo}>
          <img src={logo} alt="Logo La Romana" />
        </div>
      </div>
    </section>
  );
};


export default HeaderVolver;